export default __webpack_public_path__ + "static/media/logo-google-ads.fe9a75fc.png";